// extracted by mini-css-extract-plugin
module.exports = {"template":"styles_template__3EKuK","template__list":"styles_template__list__XJg1U","mySwiper":"styles_mySwiper__LzCe7","template__item":"styles_template__item__37mjw"};